// extracted by mini-css-extract-plugin
export var avatar = "single-video-opinion-module--avatar--5cTAT";
export var icon = "single-video-opinion-module--icon--tNXAp";
export var title = "single-video-opinion-module--title--N6l5+";
export var wrapper = "single-video-opinion-module--wrapper--djtIw";